var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopicTag(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "#ECFDF5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7300_234428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.517 6.16797C11.8265 6.16803 12.1232 6.291 12.3419 6.50983L17.4197 11.5876C17.6832 11.8527 17.8311 12.2114 17.8311 12.5852C17.8311 12.959 17.6832 13.3176 17.4197 13.5828L13.581 17.4214C13.3159 17.6849 12.9573 17.8328 12.5835 17.8328C12.2097 17.8328 11.851 17.6849 11.5859 17.4214L6.50812 12.3436C6.2893 12.1249 6.16633 11.8282 6.16626 11.5187V7.33473C6.16626 7.02529 6.28919 6.72852 6.508 6.50971C6.72681 6.2909 7.02358 6.16797 7.33302 6.16797H11.517Z",
    stroke: "#14B8A6",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7300_234428"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopicTag);
export default __webpack_public_path__ + "static/media/topic-tag.3a47870e173101aa7db388b1363d16c2.svg";
export { ForwardRef as ReactComponent };